<template>
 <div class="page-container" id="page-container" >
  <el-container id="banner-part">
    <el-header>
      <Myheader></Myheader>
    </el-header>
    <el-main>
      <div class="banner-part">
        <el-row>
        <el-col :span="24" class="banner">
          <img :src="bannerText1" class="banner-text"/>
          <img :src="bannerText2" class="banner-text2"/>
          <img :src="bannerText3" class="banner-text3"/>
        </el-col>
      </el-row>
      </div>
      <div id="solution-part" class="solution-part">
        <el-row>
        <el-col :span="24" class="solution-part-title">
          <div>行业解决方案</div>
        </el-col>
        <el-col :span="24">
          <div class="solution-items" :class="{'mobile-width':mobilePage}">
            <el-row  :gutter="20">
              <el-col :span="8" class="solution-item">
                <div class="government-bg" @click="gotoGovernment">
                  <div class="solution-item-title multiline-overflow">
                    {{ government.title }}
                  </div>
                  <div class="solution-item-data multiline-overflow">
                    {{ government.data }}
                  </div>
                </div>
                <!-- <img :src="solutionDtlImg" class="solution-dtl-img" @click="gotoGovernment"> -->
              </el-col>
              <el-col :span="8" class="solution-item">
                <div class="manufacture-bg" @click="gotoManufacture">
                  <div class="solution-item-title multiline-overflow">
                    {{ manufacture.title }}
                  </div>
                  <div class="solution-item-data multiline-overflow">
                    {{ manufacture.data }}
                  </div>
                </div>
                <!-- <img :src="solutionDtlImg" class="solution-dtl-img" @click="gotoManufacture"> -->
              </el-col>
              <el-col :span="8" class="solution-item">
                <div class="park-bg" @click="gotoPark">
                  <div class="solution-item-title multiline-overflow">
                    {{ park.title }}
                  </div>
                  <div class="solution-item-data multiline-overflow" v-html="park.data">
                  </div>
                </div>
                <!-- <img :src="solutionDtlImg" class="solution-dtl-img" @click="gotoPark"> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class=" jrkl-text">
                  <div class="jrkl-left">
                      <div class="jrkl-title">
                        金融科技解决方案
                      </div>
                      <div class="jrkl-content">
                        基于大数据、云计算、人工智能、区块链等一系列技术创新，全面应用于支付清算、借贷融资、财富管理、零售银行、保险、交易结算等金融领域。增强运营的敏捷性和灵活性，将是银行和金融机构最优先级任务。重塑业务模式、推动运营转型，让“极致数字化”成为未来金融的核心。
                      </div>
                      <div class="jrkl-content" style="-webkit-line-clamp: 6;" v-if="!mobilePage">
                        我们的团队不仅为从证券后台业务管理系统到投资家用在线证券交易系统的证券领域的大部分业务提供IT服务，而且凭借长期从事银行、保险业务系统的开发与运行维护，拥有丰富的开发经验和行业知识，在保证客户信息安全的同时，可提供从战略咨询，需求分析，运用设计，建设实施到运行维护为止的一揽子IT服务，实现客户的投资效益最大化。
                      </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      </div>
      <div id="news-part" class="news-part">
        <div class="news-part-title">
          新闻动态
        </div>
        <div class="news-data" :class="{'mobile-width':mobilePage}">
            <el-row :gutter="30">
              <el-col :span="12">
                <div class="news-type">公司新闻 <a style="font-size: 16px;font-weight: normal;float: right;margin-right: 5px;cursor: pointer;" @click.stop="viewNewsList('1')">更多 >></a></div>
                <div @click.stop="gotoNewsDetal(news.id,'0')" style="height: 270px;">
                  <img class="news-image" :src="news.image"/>
                  <div class="news-title multiline-overflow" v-html="news.title" :title="news.title">
                  </div>
                  <div class="news-content multiline-overflow" v-html="news.content">
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="news-type">行业动态 <a style="font-size: 16px;font-weight: normal;float: right;margin-right: 5px;cursor: pointer;" @click="viewNewsList('2')">更多 >></a></div>
                <el-row class="industry-items">
                  <el-col :span="24" class="industry-item" v-for="(industry,index) in industryList" :key="index">
                    <el-row :gutter="20">
                      <div  @click.stop="gotoNewsDetal(industry.id,'1')">
                        <el-col :span="10">
                          <img :src="industry.image" class="industry-image" />
                        </el-col>
                        <el-col :span="14">
                          <div class="industry-title multiline-overflow" :title="industry.title">
                            <span v-html="industry.title"></span>
                          </div>
                          <div class="industry-content multiline-overflow"   v-html="industry.content">
                          </div>
                          <div class="industry-view" >了解详情 &gt;</div>
                        </el-col>
                      </div>
                    </el-row>
                    <div class="industry-split-line"></div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
        </div>
      </div>
      <div id="ecology-part" class="ecology-part">
          <div class="ecology-part-container" :class="{'mobile-width':mobilePage}">
            <el-row :gutter="10" >
              <el-col :span="24" class="ecology-part-title">
                <div>全方位生态优势</div>
              </el-col>
              <el-col :span="8">
                <div class="ecology-left-img">
                    <div class="ecology-left-title">全覆盖的信息解决方案</div>
                    <div class="ecology-left-data">
                      基于丰富的项目经验，江苏海隆华思拥有丰富的信息解决方案，提供丰富的原生态技术与经验，满足多行业的客户场景需求。
                    </div>
                </div>
              </el-col>
              <el-col :span="16">
                  <el-col :span="24">
                    <div class="ecology-right-img">
                      <div class="ecology-right-title">全链路生命周期开发服务</div>
                      <div class="ecology-right-data">
                        打造金融科技、智能制造、数字政务及全域数据管理服务的“3+1”核心业务，为客户提供一站式智能化管理解决方案。
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="ecology-right1-img">
                      <div class="ecology-right1-title">多样化定制开发</div>
                      <div class="ecology-right1-data">
                        结合互联网发展趋势，满足不同企业规模对于数字化升级需求，推动业务发展。
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="ecology-right2-img">
                      <div class="ecology-right2-title">负责售后服务</div>
                      <div class="ecology-right2-data">
                        以客户为中心的产品售后服务，满足客户定制化需求
                      </div>
                    </div>
                  </el-col>
              </el-col>
          </el-row>
          </div>
      </div>
      <div id="about-part" class="about-part" >
        <div class="about-part-container" :class="{'mobile-width':mobilePage}">
          <div class="about-title"> 关于我们</div>
          <div class="about-desc">
            江苏海隆华思计算机系统有限公司隶属于国内知名软件企业上海海隆集团，是一家从事软件研发、物联网应用及服务外包等领域的综合性计算机软件企业，致力于为海内外客户提供优质的信息化解决方案。公司成立于2009年7月，注册资金1000万人民币。
          </div>
          <div class="about-desc">
            由技术团队自主研发，打造了金融科技、智能制造、数字政务及物联网综合应用的“3+1”核心业务，为客户提供一站式智能化管理解决方案。
          </div>

          <div class="about-desc">
            未来，我们立足于南通，辐射全国，依托“科技创新，数字赋能”，抢抓数字经济发展和数字化转型的机遇，建成华东地区领先的以产学研结合为特色的智能科技研发中心。
          </div>
          <el-row :gutter="15" style="width:65%;margin-top: 30px;">
            <el-col :span="8">
              <div class="about-num"><Rollnum :num="aboutData.areaNum"/></div>
              <div class="about-num-deac">总占地面积/平方米</div>
            </el-col>
            <el-col :span="8">
              <div class="about-num"><Rollnum :num="aboutData.userNum" suffix="+"/></div>
              <div class="about-num-deac">拥有员工</div>
            </el-col>
            <el-col :span="8">
              <div class="about-num"><Rollnum :num="aboutData.proNum" suffix="%"/></div>
              <div class="about-num-deac">科技研发团队占比</div>
            </el-col>
          </el-row>
          <div style="width:100%;margin-top: 80px;margin-bottom: 30px;height: 100px;font-size: 14px;">
            <div style="width:20%;float: left;">
              <div style="width:70px;height:70px;margin: auto;">
                <img style="width:100%;height:100%;" src="../../static/images/certificate-1.png">
              </div>
              <p style="line-height:20px;">质量管理体系认证</p>
            </div>
            <div style="width:20%;float: left;">
              <div style="width:70px;height:70px;margin: auto;">
                <img style="width:100%;height:100%;" src="../../static/images/certificate-2.png">
              </div>
              <p style="line-height:20px;">信息安全管理体系认证</p>
            </div>
            <div style="width:20%;float: left;">
              <div style="width:70px;height:70px;margin: auto;">
                <img style="width:100%;height:100%;" src="../../static/images/certificate-3.png">
              </div>
              <p style="line-height:20px;">高新技术企业</p>
            </div>
            <div style="width:20%;height:70px;float: left;">
              <div style="width:70px;height:70px;margin: auto;">
                <img style="width:100%;height:100%;" src="../../static/images/certificate-4.png">
              </div>
              <p style="line-height:20px;">信息技术服务认证</p>
            </div>
            <div style="width:20%;float: left;">
              <div style="width:70px;height:70px;margin: auto;">
                <img style="width:100%;height:50px;margin-top: 10px;" src="../../static/images/certificate-5.png">
              </div>
              <p style="line-height:20px;">双软认证</p>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <Mybottom/>
  </el-container>
  <!-- <ApplyUse :top="100" :bottm="2250" v-on:openApply="openApply"></ApplyUse> -->
  <el-dialog  id="useDialog" :visible.sync="dialogVisible" width="400px" :before-close="closeApply">
    <div slot="title" class="dialog-header">
      申请合作
    </div>
    <div class="dialog-body">
       <div class="dialog-label"><label class="label-mark">·</label>联系方式</div>
       <div class="dialog-input">
          <div class="input-name">
            <el-input type="text" placeholder="您的姓名" v-model="appLyUse.userName" clearable/>
          </div>
          <div class="input-phone">
            <el-input type="text" placeholder="您的手机号"  v-model="appLyUse.phone" clearable/>
          </div>
       </div>
       <div class="dialog-label"><label class="label-mark">·</label>需求说明</div>
       <div class="dialog-input">
          <el-input type="textarea" rows="4" placeholder="简单描述您的需求，或者想了解那个产品"  v-model="appLyUse.remark" clearable/>
       </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" style="width:100%;font-size: 22px;" @click="saveAppeal">立即申请</el-button>
    </div>
  </el-dialog>
 </div>
</template>

<script>
import Mybottom from '../components/pageBottom/bottom.vue'
import Myheader from '../components/pageHeader/header.vue'
import Rollnum from '../components/rollNum/rollNum.vue'
import ApplyUse from '../components/applyUse/applyUse.vue'
import { queryNewsList, saveAppeal } from '@/api/api.js'
import { getSign } from '@/utils/md5.js'
import { Message } from 'element-ui'
export default {
  name: 'index',
  data () {
    return {
      mobilePage: false,
      bannerText1: require('../../static/images/bannerText1.png'),
      bannerText2: require('../../static/images/bannerText2.png'),
      bannerText3: require('../../static/images/bannerText3.png'),
      solutionDtlImg: require('../../static/images/solution-dtl.png'),
      government: {
        title: '数字政务解决方案',
        data: '建设公共云平台、综合信息库、数据贡献交换平台、城市运行指挥中心、社会治理网络化综合信息服务平台等系统核心基础设施，有序推进城市数字政务、智慧应急、智慧医疗、“互联网+先进制造业等信息化应用设施，不断提升城市管理智慧化水平。'
      },
      manufacture: {
        title: '智能制造解决方案',
        data: '平台集成了多种智能工厂系统、智能车间硬件终端，将互联网、云计算、大数据、移动应用等新技术与生产管理深度融合，涵盖了订单跟踪、智能排产、技术工艺管理、生产过程追踪、设备监控、质量管理、大数据分析及可视化看板等系统，实现数字驱动制造，生产模式创新变革。'
      },
      park: {
        title: '物联网应用综合解决方案',
        data: '支持相关智能硬件对接，实现道闸系统、智能门禁、智能抄表、智能监控、智能巡检、智能楼宇等园区智能化场景管理。帮助园区构建统一组织管理体系、业务管理平台和对外服务平台，赋能数字化园区管理助力产业园区全面转型和升级。<br />应用场景：智慧园区、智慧工厂'
      },
      news: {
        id: null,
        image: null,
        title: null,
        date: '01-20',
        content: null
      },
      industryList: [
      ],
      companyQr: require('../../static/images/company-qr.png'),
      wechatQr: require('../../static/images/wechat-qr.png'),
      aboutData: {
        areaNum: 0,
        userNum: 0,
        proNum: 0
      },
      dialogVisible: false,
      appLyUse: {
        userName: '',
        phone: '',
        remark: ''
      }
    }
  },
  metaInfo: {
    title: '江苏海隆华思计算机系统有限公司',
    meta: [
      {name: 'keywords', content: '江苏海隆华思，海隆华思，华思，智慧园区，数字政务，智能制造'},
      {name: 'description', content: '数字化解决方案服务商，全方位为政企提供优质服务'}
    ]
  },
  components: {
    Mybottom,
    Rollnum,
    ApplyUse,
    Myheader
  },
  created () {
    // eslint-disable-next-line no-use-before-define
    var _hmt = _hmt || []
    var hm = document.createElement('script')
    hm.src = 'https://hm.baidu.com/hm.js?414568d3cd03c88e2a59590b7360fb70'
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(hm, s)

    this.getNewsList()
    this.getIndustryList()
  },
  mounted () {
    if (navigator.userAgent.match(/mobile/i)) {
      this.mobilePage = true
    }
    if (this.$route.query.partId) {
      var partId = this.$route.query.partId
      this.goPart(partId)
    }
    window.addEventListener('scroll', this.handleScroll, true)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    goPart (partId) {
      this.bannerSelTag = false
      this.solutionSelTag = false
      this.newsSelTag = false
      this.ecologySelTag = false
      this.aboutSelTag = false
      this.contactSelTag = false
      switch (partId) {
        case 'solution-part':
          this.solutionSelTag = true
          break
        case 'news-part':
          this.newsSelTag = true
          break
        case 'ecology-part':
          this.ecologySelTag = true
          break
        case 'about-part':
          this.aboutSelTag = true
          break
        case 'contact-me':
          this.contactSelTag = true
          break
        default :
          this.bannerSelTag = true
          break
      }
      document.getElementById(partId).scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      })
    },
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // var offsetTop = document.querySelector('#page-container').offsetTop
      var aboutPartTop = document.querySelector('#about-part').offsetTop
      // console.log(offsetTop)

      if (this.mobilePage) {
        if (scrollTop > 560) {
          this.aboutData = {
            areaNum: 2400,
            userNum: 250,
            proNum: 95
          }
        }
      } else {
        if (scrollTop > (aboutPartTop - 440)) {
          this.aboutData = {
            areaNum: 2400,
            userNum: 250,
            proNum: 95
          }
        }
      }
    },
    gotoGovernment () {
      window.open('/gov/index.html', '_blank')
    },
    gotoManufacture () {
      window.open('/mes/index.html', '_blank')
    },
    gotoPark () {
      window.open('/park/index.html', '_blank')
    },
    gotoNewsDetal (id, type) {
      const {href} = this.$router.resolve({
        path: '/newsDetail',
        query: {id: id, type: type}
      })
      window.open(href, '_blank')
    },
    viewNewsList (type) {
      const {href} = this.$router.resolve({
        path: '/newsList',
        query: {type: type}
      })
      window.open(href, '_blank')
    },
    getNewsList () {
      this.loading = true
      const jsonData = "{'type':'0'}"
      const sign = getSign('getNewsList')
      this.$http({
        url: queryNewsList + '?Operation=getNewsList&jsonData=' + jsonData + '&sign=' + sign,
        method: 'get'
      }).then(({ data }) => {
        // 处理
        this.loading = false
        if (data.Code === 200) {
          var resultList = data.Data
          if (resultList && resultList.length > 0) {
            this.news = {
              id: resultList[0].NID,
              image: '/uploads/' + resultList[0].Path,
              title: resultList[0].NTITLE,
              date: resultList[0].NDATETIME,
              content: resultList[0].NCONTENT
            }
          }
        } else {
          let errorMsg = '获取新闻动态失败！'
          if (data && !data.Msg) {
            errorMsg = data
          } else {
            errorMsg = data.Msg
          }
          Message.error(errorMsg)
        }
      })
    },
    getIndustryList () {
      this.loading = true
      const jsonData = "{'type':'1'}"
      const sign = getSign('getNewsList')
      this.$http({
        url: queryNewsList + '?Operation=getNewsList&jsonData=' + jsonData + '&sign=' + sign,
        method: 'get'
      }).then(({ data }) => {
        // 处理
        this.loading = false
        if (data.Code === 200) {
          var resultList = data.Data
          if (resultList && resultList.length > 0) {
            resultList.forEach((item, index) => {
              if (index <= 2) {
                var industry = {
                  id: item.NID,
                  image: '/uploads/' + item.Path,
                  title: item.NTITLE,
                  date: item.NDATETIME,
                  content: item.NCONTENT
                }
                this.industryList.push(industry)
              }
            })
          }
        } else {
          let errorMsg = '获取行业动态失败！'
          if (data && !data.Msg) {
            errorMsg = data
          } else {
            errorMsg = data.Msg
          }
          Message.error(errorMsg)
        }
      })
    },
    openApply () {
      this.appLyUse = {
        userName: '',
        phone: '',
        remark: ''
      }
      this.dialogVisible = true
    },
    saveAppeal () {
      if (this.appLyUse.userName === '') {
        Message.warning('联系人姓名不能为空！')
        return false
      }
      if (this.appLyUse.phone === '') {
        Message.warning('联系方式不能为空！')
        return false
      }
      // if (this.appLyUse.remark === '') {
      //   Message.warning('联系人姓名不能为空！')
      //   return false
      // }
      this.loading = true
      // console.log(JSON.stringify(this.appLyUse))
      // eslint-disable-next-line no-control-regex
      const jsonData = encodeURIComponent(JSON.stringify(this.appLyUse))
      const sign = getSign('saveAppeal')
      this.$http({
        url: saveAppeal + '?Operation=saveAppeal&jsonData=' + jsonData + '&sign=' + sign,
        method: 'post'
      }).then(({ data }) => {
        // 处理
        this.loading = false
        if (data.Code === 200) {
          this.dialogVisible = false
          Message.success('提交成功，请等待客户经理联系您')
        } else {
          let errorMsg = '提交合作需求失败！'
          if (data && !data.Msg) {
            errorMsg = data
          } else {
            errorMsg = data.Msg
          }
          Message.error(errorMsg)
        }
      })
    },
    closeApply () {
      this.$confirm('真的忍心放弃联系我们吗？', '提示', {
        confirmButtonText: '残忍离开',
        cancelButtonClass: '取消',
        type: ''
      }).then(() => {
        this.dialogVisible = false
      })
    }
  }
}
</script>

<style>
  #useDialog .el-dialog__header{
    padding: 0px;
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mobile-width {
    width: 95% !important;
  }
  #useDialog .dialog-header{
    text-align: center;
    background-image: url('../../static/images/apply-title-bg.png');
    background-size: 100% 100%;
    height: 80px;
    line-height: 80px;
    color: white;
    font-size: 22px;
  }
  #useDialog .dialog-label{
    text-align: left;
    font-weight: bold;
    line-height: 30px;
  }
  .dialog-label .label-mark{
    color: blue;
    line-height: 30px;
    padding: 0px 2px;
    font-weight: 800;
  }
  #useDialog .dialog-input{
    line-height: 30px;
  }
  .input-name{
    float: left;
    width: 140px;
  }
  #useDialog .input-phone{
    float: left;
    width: 210px;
    margin-left: 10px;
  }
  #useDialog.dialog-footer{
    text-align: center;
  }
  .el-header{
    height: 70px !important;
    padding: 0px;
  }
  .page-header .logo{
    height: 100%;
  }
  .page-header .menu{
    height: 100%;
  }
  .flexBox{
    display: flex;
    align-items: center;
  }
  .tabBox{
    width: 100%;
    height: 70px;
    background-color: #fff;
    cursor: pointer;
  }
  .content{
    width: 65%;
    margin: auto;
    position: relative;
  }
  .pageBox .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    opacity: 1;
    color: black;
  }
  .tabContainer{
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: space-between;
  }
  .topTab{
    width: 62%;
    justify-content: flex-end;
  }
  .topTab li{
    width: 16.7%;
    cursor: pointer;
    text-align: center;
  }
  .topTab li span{
    color: #4E4E4E;
    height: 80px;
    font-size: 16px;
  }
  .topTab li.active span{
    color: #0065F3;
    font-weight: 700;
    /* border-bottom: 3px solid #0065F3; */
    display: inline-block;
    line-height:80px;
  }
  .logo .logo-img{
    text-align: center;
    padding: 15px 0px;
  }
   .menu-items{
    width: 60%;
    line-height: 50px;
    cursor: pointer;
  }
  .menu-items .menu-item{
    padding-top: 5px;
    font-size: 16px !important;
    color: grey;
    cursor: pointer;
  }
  .menu-item-select{
    color: #0451db !important;
    font-weight: 700;
  }
  .el-main {
    padding: 0px;
    overflow: hidden;
  }
  .banner-part{
    height: 550px;
    width: 100%;
  }
  .banner-part .el-row{
    height: 100%;
  }
  .banner-part .banner{
    height: 100%;
    width: 100%;
    background-image: url('../../static/images/banner.png');
    position: absolute;
    background-size: 100% 100%;
  }
  .banner .banner-text{
    width: 525px;
    height: 60px;
    position: absolute;
    left: 17.5%;
    top: 32%;
    animation: banner 1s linear forwards;
  }
  .banner .banner-text2{
    width: 360px;
    height: 10px;
    position: absolute;
    left: 17.5%;
    top: -1000px;
    animation: banner2 1.5s linear forwards;
  }
  .banner .banner-text3{
    width: 525px;
    height: 100px;
    position: absolute;
    left: 17.5%;
    top: 500px;
    animation: banner3 1.5s linear forwards;
  }
  @keyframes banner {
    0%{
      left: -850px;
    }
    100%{
      left: 17.5%;
    }
}
@keyframes banner2 {
    0%{
      top: -1000px;
    }
    100%{
      top: 49%;
    }
}

@keyframes banner3 {
    0%{
      top: 500px;
    }
    100%{
      top: 55%;
    }
}

  .solution-part{
    height: 939px;
    margin-top: 50px;
  }

  .solution-part .solution-part-title{
    font-size: 41px;
    color: black;
    font-weight: 700;
  }
  .solution-part .solution-items {
    width: 63%;
    margin: auto;
    margin-top: 35px;
  }
  .solution-items .solution-item{
    height: 465px;
    cursor: pointer;
    position: relative;
  }
   .solution-items .solution-dtl-img{
      position:absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 10%;
      display: none;
      z-index: 100;
  }
  .government-bg{
    height: 100%;
    width: 100%;
    background-image: url('../../static/images/government_bg.png');
    background-size: 100% 100%;
  }

  .government-bg:hover + .solution-dtl-img{
      display: block;
    }
  .manufacture-bg{
    height: 100%;
    width: 100%;
    background-image: url('../../static/images/manufacture_bg.png');
    background-size: 100% 100%;
  }
  .manufacture-bg:hover + .solution-dtl-img{
      display: block;
    }
  .park-bg{
    height: 100%;
    width: 100%;
    background-image: url('../../static/images/park_bg.png');
    background-size: 100% 100%;
  }
  .park-bg:hover + .solution-dtl-img{
      display: block;
    }
    .solution-dtl-img:hover{
       display: block;
    }
  .government-bg:hover{
    -webkit-box-shadow: 0 15px 30px rgba(0,0,0,3);
    box-shadow:  0 15px 30px rgba(0,0,0,3);
    -webkit-transform: translate3d(0,-2px,0);
    transform: translate3d(0,-2px,0);
  }
  .manufacture-bg:hover{
    -webkit-box-shadow: 0 15px 30px rgba(0,0,0,3);
    box-shadow:  0 15px 30px rgba(0,0,0,3);
    -webkit-transform: translate3d(0,-2px,0);
    transform: translate3d(0,-2px,0);
  }
.park-bg:hover{
    -webkit-box-shadow: 0 15px 30px rgba(0,0,0,3);
    box-shadow:  0 15px 30px rgba(0,0,0,3);
    -webkit-transform: translate3d(0,-2px,0);
    transform: translate3d(0,-2px,0);
  }
  .solution-item .solution-item-title{
    margin: 0px 30px;
    padding-top: 30px;
    border-bottom: 1px solid white;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    color: white;
    font-weight: 600;
    opacity: 0.9;
    -webkit-line-clamp: 1;
  }
  .solution-item .solution-item-data{
    padding: 15px 30px;
    height: 190px;
    line-height: 25px;
    font-size: 14px;
    text-indent: 28px;
    color: white;
    text-align: left;
    -webkit-line-clamp: 8;
    opacity: 0.9;
  }
  .jrkl-text {
    width: 100%;
    height: 404px;
    margin-top: 20px;
    background-image: url('../../static/images/jrkj-bg.png');
    background-size: 100% 100%;
  }
  .jrkl-text .jrkl-left {
    float: left;
    width: 45%;
    height: 404px;
    padding: 20px;
  }
  .jrkl-left .jrkl-title {
    font-size: 20px;
    color: black;
    font-weight: 600;
    line-height: 45px;
    margin: 0px 20px;
    border-bottom: 1px solid rgb(177, 174, 174);
  }
  .jrkl-left .jrkl-content {
    margin: 10px 20px;
    font-size: 14px;
    text-indent: 28px;
    color: grey;
    text-align: left;
    line-height: 25px;
  }
  .news-part{
    width: 100%;
    height: 565px;
    margin-top: 50px;
    background-image: url('../../static/images/news_bg.png');
    background-size: 100% 100%;
  }
  .news-part .news-part-title{
    font-size: 41px;
    color: black;
    font-weight: 700;
    padding-top: 35px;
  }
  .news-part .news-data{
    width: 63%;
    margin: auto;
  }
  .news-data .news-type{
    height: 25px;
    line-height: 25px;
    margin: 35px 0px 15px 0px;
    text-align: left;
    font-size: 20px;
    font-weight: 600;
  }
  .news-type a:hover{
    color: #0451db;
  }
  .news-data .news-image{
      height: 100%;
      width: 100%;
      border-radius: 10px;
      cursor: pointer;
  }
  .news-data .news-title{
      padding: 10px 0px;
      font-size: 16px;
      font-weight: 600;
      text-align: left;
      line-height: 20px;
      height: 30px;
      cursor: pointer;
      -webkit-line-clamp: 2;
  }
  .news-data .news-content{
      font-size: 12px;
      line-height: 25px;
      text-align: left;
      color: grey;
      cursor: pointer;
      -webkit-line-clamp: 2;
  }
  .industry-items {
    cursor: pointer;
  }
  .industry-items .industry-item{
    height: 100px;
    margin-bottom: 15px;
  }
  .industry-item .el-row, .el-col{
    height: 100%;
  }
  .industry-item .industry-image{
    height: 105px;
    width: 100%;
    border-radius: 10px;
  }
  .industry-item .industry-title{
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    line-height: 20px;
    height: 40px;
    -webkit-line-clamp: 2;
  }
  .industry-item .industry-content{
    font-size: 12px;
    line-height: 20px;
    text-align: left;
    color: grey;
    -webkit-line-clamp: 2;
  }
  .industry-item  .industry-view{
    font-size: 12px;
    text-align: left;
    color: #0451db;
    cursor: pointer;
    line-height :25px;
  }
  .industry-item:nth-child(n+2){
    margin-top: 20px;
  }
  .industry-split-line{
    border-bottom: 1px solid rgb(177, 174, 174);
    height: 18px;
  }
  .industry-item:last-child .industry-split-line{
    display: none;
  }
  .ecology-part{
    margin-top: 50px;
    height: 520px;
  }
  .ecology-part .ecology-part-container{
    width: 63%;
    margin: auto;
  }
  .ecology-part .ecology-part-title{
    width: 100%;
    font-size: 41px;
    color: black;
    font-weight: 700;
    /* padding-top: 35px; */
    text-align: center;
    margin-bottom: 35px;
  }

  .ecology-part .ecology-left-img{
    height: 410px;
    background-image: url('../../static/images/ecology-1.png');
    background-size: 100% 100%;
  }
  .ecology-part  .ecology-right-img{
    height: 195px;
    background-image: url('../../static/images/ecology-2.png');
    background-size: 100% 100%;
    margin-bottom: 10px;
  }
  .ecology-part  .ecology-right1-img{
    height: 195px;
    background-image: url('../../static/images/ecology-3.png');
    background-size: 100% 100%;
    margin-top: 10px;
  }
  .ecology-part  .ecology-right2-img{
    height: 195px;
    background-image: url('../../static/images/ecology-4.png');
    background-size: 100% 100%;
    margin-top: 10px;
  }
  .ecology-left-img .ecology-left-title{
    font-size: 20px;
    font-weight: 600;
    color: white;
    text-align: left;
    padding: 40px 25px 25px 25px;
    opacity: 0.9;
  }
  .ecology-left-img .ecology-left-data{
    font-size: 14px;
    color: white;
    text-align: left;
    padding: 0px 25px;
    line-height: 25px;
    opacity: 0.9;
  }
  .ecology-right-img .ecology-right-title{
    font-size: 20px;
    font-weight: 600;
    color: white;
    text-align: left;
    padding: 40px 25px 25px 25px;
    opacity: 0.9;
  }
  .ecology-right-img .ecology-right-data{
    font-size: 14px;
    color: white;
    text-align: left;
    padding: 0px 25px;
    line-height: 25px;
    opacity: 0.9;
    width: 60%;
  }
  .ecology-right1-img .ecology-right1-title{
    font-size: 20px;
    font-weight: 600;
    color: white;
    text-align: left;
    padding: 40px 25px 25px 25px;
    opacity: 0.9;
  }
  .ecology-right1-img .ecology-right1-data{
    font-size: 14px;
    color: white;
    text-align: left;
    padding: 0px 25px;
    line-height: 25px;
    opacity: 0.9;
    width: 55%;
  }
  .ecology-right2-img .ecology-right2-title{
    font-size: 20px;
    font-weight: 600;
    color: white;
    text-align: left;
    padding: 40px 25px 25px 25px;
    opacity: 0.9;
  }
  .ecology-right2-img .ecology-right2-data{
    font-size: 14px;
    color: white;
    text-align: left;
    padding: 0px 25px;
    line-height: 25px;
    opacity: 0.9;
    width: 60%;
  }
  .about-part{
    width: 100%;
    height: auto;
    padding-bottom: 20px;
    margin-top: 50px;
    background-image: url('../../static/images/about.png');
    background-size: 100% 100%;
  }
  .about-part .about-part-container{
    width: 63%;
    margin: auto;

  }
  .about-part .about-title{
    text-align: left;
    width: 100%;
    font-size: 41px;
    color: black;
    font-weight: 700;
    padding-top: 60px;
    margin-bottom: 35px;
  }
  .about-part .about-desc{
    text-align: left;
    font-size: 16px;
    width: 70%;
    text-indent: 31px;
    line-height: 28px;
    color: grey;
  }
  .about-part .about-num{
    text-align: left;
    font-size: 50px;
    color: black;
    font-weight: 600;
  }
  .about-part  .about-num-deac{
    text-align: left;
    color: grey;
    font-size: 12px;
  }
  .foot-part{
    height: 318px !important;
    line-height: 40px !important;
    background-image: url('../../static/images/foot-bg.png');
    background-size: 100% 100%;
    padding: 0px;
  }
  .foot-part .foot-part-container{
    width: 65%;
    margin: auto;
  }
  .foot-part .foot-title{
    text-align: left;
    width: 100%;
    font-size: 30px;
    color: black;
    font-weight: 700;
    padding-top: 60px;
    margin-bottom: 10px;
  }
  .foot-part  .foot-title-desc{
    font-size: 20px;
    text-align: left;
  }
  .foot-part .about-tell{
      font-size: 30px;
      text-align: left;
      margin-top: 18px;
      height: 50px;
      line-height: 50px;
      position: relative;
  }
  .foot-part .tell-tag{
    background-color: #0550DC;
    color: white;
    opacity: 0.9;
    padding: 3px 10px;
    font-size: 20px;
    letter-spacing: 4px;
    height: 40px;
    line-height: 40px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    width: 115px;
    bottom: 0;
    text-align: center;
  }
  .foot-part  .tell-phone{
    height: 50px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 145px;
    width: 200px;
    bottom: 0;
    font-size: 40px;
    color: black;
    font-weight: 700;
  }
  .foot-part  .company-name{
    margin-top: 25px;
    text-align: left;
    font-size: 16px;
    color: #626A7E;
    line-height: 8px;
  }
  .company-name p {
    height: 13px;
    margin: 10px 0px;
   }
  .foot-part  .company-address{
    text-align: left;
    font-size: 16px;
    color: #626A7E;
  }
  .foot-part  .qr-items-title{
    font-size: 24px;
    color: black;
    font-weight: 700;
    margin-top: 75px;
    margin-bottom: 15px;
  }
  .foot-part  .company-qr{
    width: 103px;
    height: 103px;
  }
  .foot-part  .wechat-qr{
    width: 103px;
    height: 103px;
  }
  .foot-part .company-qr-remark{
    line-height: 20px;
    font-size: 14px;
  }
  .foot-part .wechat-qr-remark{
    line-height: 20px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue